import type { AppCatalogStatus, ProtoTimestamp } from '@/types';

export const APP_STATUS_OPTIONS: Array<{
  value: AppCatalogStatus;
  label: string;
  color: string;
}> = [
  { value: 'draft', label: '草稿', color: 'default' },
  { value: 'published', label: '已发布', color: 'green' },
  { value: 'hidden', label: '隐藏', color: 'gold' },
  { value: 'disabled', label: '禁用', color: 'red' },
  { value: 'archived', label: '已归档', color: 'default' },
];

export function getStatusMeta(status: AppCatalogStatus | string) {
  return (
    APP_STATUS_OPTIONS.find((item) => item.value === status) ?? {
      value: status,
      label: status || '-',
      color: 'default',
    }
  );
}

export function formatProtoTimestamp(value: ProtoTimestamp) {
  if (!value) {
    return '-';
  }

  if (typeof value === 'string') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '-' : date.toLocaleString('zh-CN');
  }

  const seconds = Number(value.seconds ?? 0);
  if (!Number.isFinite(seconds) || seconds <= 0) {
    return '-';
  }

  return new Date(seconds * 1000).toLocaleString('zh-CN');
}

export function formatBytes(value: number) {
  if (!Number.isFinite(value) || value <= 0) {
    return '-';
  }

  const units = ['B', 'KB', 'MB', 'GB'];
  let size = value;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex += 1;
  }

  return `${size.toFixed(unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
}
